<template lang="pug">
div
  .h-vertical-align-container(v-if="modalShow")
    .modal__close(@click='overlay()')
    .modal__overlay(@click='overlay()')
    .videoModal__wrapper
      .fluid__video#fluid__video--tutorial(v-html='ytVideo') {{ytVideo}}

  section.full__video
    .intro__content.intro__content--mobile
      h1.blendeo Blendeo
      h2 Moving Long Exposures
      .btn__group.btn__group--splash
        a.btn.btn--purpleLight.btn__splash(href='http://apple.co/Blendeo') Download free trial
        get-plan(
          classes='btn btn--white'
          isBlendeo='true'
        )
    .fluid__video
      .intro__content.intro__content--desktop
        h1.blendeo Blendeo
        h2 Moving Long Exposures
        .btn__group.btn__group--splash
          a.btn.btn--purpleLight.btn__splash(href='http://apple.co/Blendeo') Download free trial
          get-plan(
            classes='btn btn--white'
            isBlendeo='true'
          )
      iframe(data-src='https://media.flixel.com/cinemagraph/hdfoevfxpqewvdgqolf3?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/AndrewPavlidis/') AndrewPavlidis

  brands

  section
    .product__section
      .product__section--container.product__section--reverse
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@2x.png 2x,https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@1x.png 1x')
            h2
              | Blendeo
              span for iOS
          .productItem__desc
            p Create professional quality long exposures on-the-go with your iPhone or iPad. Simply capture for up to 5 minutes or import a video and edit the perfect long exposure by adjusting the Exposure Time control and timeline range in Blendeo.
            .btn__group
              a.btn.btn--black(href='http://apple.co/Blendeo') Download free trial
              get-plan(
                classes='btn btn--white'
                isBlendeo='true'
              )
        .product__section--image
          img.lazy.blendeo(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@1x.png 1x')

  section
    .product__section
      .product__section--highlights
        .highlights--title
          h2 An Advanced Long Exposure Editor for iOS
          p The hardest part of creating amazing long exposure photos and videos is out of the control of even the best photographers. With Blendeo you don’t need to get lucky, you control time.

        .highlights
          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/capture@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/capture@1x.png')
            .highlight__item--title
              h3 Not Just Photos
            .highlight__item--desc
              p Capture for up to 5 minutes or import a video recorded on a tripod to start editing the perfect long exposure in Blendeo. Choose a still image on the timeline to create mesmerizing long exposure photos or switch to video mode and control the timeline range and speed.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/exposure@2x.jpeg 2x, https://cdn.flixel.com/static/static-web/products/blendeo/exposure@1x.jpeg 1x')
            .highlight__item--title
              h3 Exposure Time Control
            .highlight__item--desc
              p No need for ND filters, calculating shutter speed, aperture, or ISO. Imagine going back in time to choose the best moment that produces a magical long exposure. Simply increase the exposure time to blur or streak the moving elements from your video.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/editors@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/editors@1x.png 1x')
            .highlight__item--title
              h3 Motion Blur and Light Trails
            .highlight__item--desc
              p Blur water and clouds and make transient objects speed by or completely disappear with an exposure time of minutes, or create beautiful streaks of light from moving vehicles, fireworks, stars and more.

          .highlight__item
            .highlight__item--icon
              img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/export@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/export@1x.png 1x')
            .highlight__item--title
              h3 Easy to Create. Easy to Share.
            .highlight__item--desc
              p Export your long exposure in various image and video file formats or share them instantly on connected social networks. Send your long exposure videos to Cinemagraph Pro to create and share magical long exposure cinemagraphs your audience will love.
  section
    .product__section
      .product__section--video
        a(href='https://www.youtube.com/watch?v=CDHyoRnrGuc' @click='ytModal($event)')
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/youtubeStill@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/youtubeStill@1x.jpeg 1x')
          .playbtn
  
  section
    .product__section
      .product__section--cta
        .productItem__title--cta
          h2 Create Long Exposure Cinemagraphs with Blendeo and Cinemagraph Pro
        .productItem__desc--cta
          p Transform long exposure videos created with Blendeo into thumb-stopping cinemagraphs using Flixel Cinemagraph Pro for macOS and iOS. Get inspired by long exposure cinemagraphs created by the Flixel Community.
          .btn__group
            a.btn.btn--blue(href='/cinemagraphs/long-exposure') View Gallery

  section
    .product__section
      .product__section--specs
        h2 System Requirements
        p iOS 11.2 or later. Compatible with iPhone, iPad, iPad Pro, iPod Touch
    
  section
    .product__section
      .product__section--press
        h2 Press
        .productItem__desc--cta         
          p Looking for more information, icons, screenshots, and sample exports?
          .btn__group
            a.btn.btn--blue(href='http://cdn.flixel.com/static/blendeo/press/BlendeoPressKit.pdf') See Press Kit

  section.flixelPlan__section
    .flixelPlan__container
      h1 Choose a plan that’s right for you
      p Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform.
      .btn__group
        get-plan(
          classes='btn btn--white'
          isBlendeo='true'
        )
  // Rich Card
  script(
    type="application/ld+json" 
    ) {{ this.$metaInfo}}
</template>

<script>
import Brands from 'components/Brands.vue';
import getPlan from 'components/getPlan.vue';
import productmixin from './productmixin.vue';

export default {
  name: 'Blendeo',
  metaInfo() {
    return {
      title: 'Blendeo for iOS | Flixel',
      meta: [
        {
          'property': 'image',
          'content': 'https://cdn.flixel.com/static/static-web/BlendeoiOS.png',
        },
        {
          'property': 'description',
          'content': 'Blendeo, the most advanced long exposure photo and video editor for iOS.',
        },
        {
          'property': 'richcard',
          'content': '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Blendeo for iOS","description":"First of its kind; change exposure time after capture to blend imagery that gets noticed.","image":["https://cdn.flixel.com/static/static-web/BlendeoiOS_1_1.png","https://cdn.flixel.com/static/static-web/BlendeoiOS_4_3.png","https://cdn.flixel.com/static/static-web/BlendeoiOS_16_9.png"],"downloadUrl":"https://appstore.com/apps/blendeo","operatingSystem":"iOS 11.2 and higher","storageRequirements":"100 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.6","bestRating":"5.0","ratingCount":"11289"},"offers":{"@type":"Offer","price":"4.99","priceCurrency":"USD"}}',
        },
      ],
      script: [
        {
          innerHTML: '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Blendeo for iOS","description":"irst of its kind; change exposure time after capture to blend imagery that gets noticed.","image":["https://cdn.flixel.com/static/static-web/BlendeoiOS_1_1.png","https://cdn.flixel.com/static/static-web/BlendeoiOS_4_3.png","https://cdn.flixel.com/static/static-web/BlendeoiOS_16_9.png"],"downloadUrl":"https://appstore.com/apps/blendeo","operatingSystem":"iOS 11.2 and higher","storageRequirements":"100 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.6","bestRating":"5.0","ratingCount":"11289"},"offers":{"@type":"Offer","price":"14.99","priceCurrency":"USD"}}',
          type: 'application/ld+json',
        },
      ],
    };
  },
  data() {
    return {
      modalShow: false,
      ytVideo: '',
      modalProduct: false,
    };
  },
  mounted() {
    $(window).ready(function () {
      $(window).scrollTop(0);
    });
  },
  methods: {
    ytModal($event) {
      $event.preventDefault();
      const ytURL = $event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      const videoHeight = window.innerHeight - 200;
      const videoWidth = window.innerWidth - 200;

      this.modalShow = true;
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
      this.ytVideo = '<iframe height=' + videoHeight + ' width= ' + videoWidth + ' src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      $('body').unbind('touchmove');
      this.modalShow = false;
      this.modalProduct = false;
    },
  },
  mixins: [productmixin],
  components: {
    'Brands': Brands,
    'getPlan': getPlan,
  },
};
</script>


// WEBPACK FOOTER //
// src/views/products/blendeo.vue